(() => {
  if (customElements.get('ds-newsletter-form')) return;

  const ENDPOINT = 'https://a.klaviyo.com/client/subscriptions';
  const REVISION = '2026-10-15';

  class DsNewsletterForm extends HTMLElement {
    constructor() {
      super();
      this.onSubmit = this.onSubmit.bind(this);
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      this.input = this.form?.querySelector('input[type="email"]');
      this.button = this.form?.querySelector('button[type="submit"]');
      this.status = this.form?.querySelector('[role="status"]');
      if (!this.input || !this.button || !this.status) return;

      this.provider = this.dataset.klaviyoKey && this.dataset.klaviyoList ? 'klaviyo' : 'shopify';
      if (this.provider === 'shopify') return;
      this.form.addEventListener('submit', this.onSubmit);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('submit', this.onSubmit);
    }

    async onSubmit(event) {
      event.preventDefault();
      if (this.busy || !this.form.reportValidity()) return;

      const email = this.input.value.trim();
      this.input.value = email;
      this.setBusy(true);
      this.setStatus('');
      this.input.removeAttribute('aria-invalid');

      try {
        await this.subscribeKlaviyo(email);

        this.form.reset();
        this.input.value = '';
        this.setStatus(this.dataset.messageSuccess);
        document.dispatchEvent(new CustomEvent('ds:newsletter-subscribed', {
          detail: { email, provider: this.provider, list: this.dataset.klaviyoList, source: this.dataset.source },
        }));
      } catch {
        this.input.setAttribute('aria-invalid', 'true');
        this.setStatus(this.dataset.messageError, true);
      } finally {
        this.setBusy(false);
      }
    }

    async subscribeKlaviyo(email) {
      const response = await fetch(`${ENDPOINT}?company_id=${encodeURIComponent(this.dataset.klaviyoKey)}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/vnd.api+json',
          revision: REVISION,
        },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: this.dataset.source,
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email,
                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                  },
                },
              },
            },
            relationships: {
              list: { data: { type: 'list', id: this.dataset.klaviyoList } },
            },
          },
        }),
      });
      if (!response.ok) throw new Error(`Klaviyo responded ${response.status}`);
    }

    setBusy(busy) {
      this.busy = busy;
      this.button.disabled = busy;
      this.button.setAttribute('aria-busy', String(busy));
      this.input.readOnly = busy;
    }

    setStatus(message, isError = false) {
      this.status.textContent = message || '';
      this.status.dataset.state = message ? (isError ? 'error' : 'success') : '';
      this.status.classList.toggle('visually-hidden', !message);
      this.status.classList.toggle('ds-newsletter__message--error', Boolean(message && isError));
      this.status.classList.toggle('ds-newsletter__message--success', Boolean(message && !isError));
    }
  }

  customElements.define('ds-newsletter-form', DsNewsletterForm);
})();
